/**
 * Zwei-Klick-Schutz fuer Google Maps, YouTube und Vimeo.
 *
 * iframes werden serverseitig (snippets/consent-embed.liquid bzw. direkt in den Sections)
 * mit data-consent-embed="maps|youtube|vimeo" und data-consent-src statt src ausgeliefert.
 * Dieses Skript zeigt einen Platzhalter und setzt den echten src erst
 *   - nach Klick auf "Karte laden" / "Video laden" (nur dieses eine Embed) oder
 *   - sobald der Besucher bereits eingewilligt hat (Shopify Customer Privacy API,
 *     wird von Consentmo synchronisiert). Klick setzt keine Einwilligung.
 *
 * Einwilligung = marketingAllowed() || preferencesProcessingAllowed():
 * YouTube/Vimeo-Cookies gelten meist als Marketing, Google Maps als Praeferenzen/Funktional.
 * Je nach Kategorisierung im Banner reicht daher eine der beiden Kategorien.
 *
 * API: window.MszConsentEmbed.isAllowed(), .onConsent(cb), .whenAllowed(elements, kind, cb)
 */
(function () {
    'use strict';

    if (window.MszConsentEmbed) return;

    var script = document.currentScript;
    var privacyUrl = (script && script.getAttribute('data-privacy-url')) || '/policies/privacy-policy';

    var TEXTS = {
        maps: {
            text: 'Diese Karte wird von Google Maps bereitgestellt. Beim Laden werden Daten an Google übertragen.',
            button: 'Karte laden'
        },
        youtube: {
            text: 'Dieses Video wird von YouTube (Google) bereitgestellt. Beim Laden werden Daten an YouTube bzw. Google übertragen.',
            button: 'Video laden'
        },
        vimeo: {
            text: 'Dieses Video wird von Vimeo bereitgestellt. Beim Laden werden Daten an Vimeo übertragen.',
            button: 'Video laden'
        }
    };
    var PRIVACY_LABEL = 'Mehr dazu in unserer Datenschutzerklärung.';
    var COPY_CLASSES = ['slide-pc', 'slide-mb', 'slide-mobile'];

    var allowed = false;
    var pending = [];     // { iframe, placeholder }
    var callbacks = [];   // Funktionen, die nach der Einwilligung einmalig laufen
    var apiRequested = false;

    function readConsent() {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;

        try {
            return !!(privacy.marketingAllowed() || privacy.preferencesProcessingAllowed());
        } catch (e) {
            return false;
        }
    }

    function detectKind(src) {
        if (/youtube|youtu\.be/i.test(src)) return 'youtube';
        if (/vimeo/i.test(src)) return 'vimeo';
        return 'maps';
    }

    function buildPlaceholder(kind) {
        var texts = TEXTS[kind] || TEXTS.maps;
        var box = document.createElement('div');
        var inner = document.createElement('div');
        var text = document.createElement('p');
        var privacy = document.createElement('p');
        var link = document.createElement('a');
        var button = document.createElement('button');

        box.className = 'consent-embed consent-embed--' + kind;
        inner.className = 'consent-embed__inner';
        text.className = 'consent-embed__text';
        text.textContent = texts.text;
        privacy.className = 'consent-embed__privacy';
        link.href = privacyUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = PRIVACY_LABEL;
        privacy.appendChild(link);
        button.type = 'button';
        button.className = 'button consent-embed__button';
        button.textContent = texts.button;

        inner.appendChild(text);
        inner.appendChild(privacy);
        inner.appendChild(button);
        box.appendChild(inner);

        return { box: box, button: button };
    }

    function load(iframe, placeholder) {
        var src = iframe.getAttribute('data-consent-src');

        if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        iframe.style.removeProperty('display');

        if (!src) return;
        iframe.removeAttribute('data-consent-src');
        iframe.setAttribute('src', src);
    }

    function gate(iframe) {
        var src = iframe.getAttribute('data-consent-src');

        if (!src || iframe.__consentGated) return;
        iframe.__consentGated = true;

        if (allowed) {
            load(iframe);
            return;
        }

        var kind = iframe.getAttribute('data-consent-embed') || detectKind(src);
        var built = buildPlaceholder(kind);
        var box = built.box;
        var height = iframe.getAttribute('height');

        // Layout des Original-iframes uebernehmen
        if (window.getComputedStyle(iframe).position === 'absolute') {
            box.classList.add('is-fill');
        } else if (height && /^\d+$/.test(height)) {
            box.style.minHeight = height + 'px';
        } else {
            box.classList.add('is-ratio');
        }

        COPY_CLASSES.forEach(function (name) {
            if (iframe.classList.contains(name)) box.classList.add(name);
        });

        iframe.parentNode.insertBefore(box, iframe);
        iframe.style.setProperty('display', 'none', 'important');

        var entry = { iframe: iframe, placeholder: box };
        pending.push(entry);

        built.button.addEventListener('click', function () {
            pending = pending.filter(function (item) { return item !== entry; });
            load(iframe, box);
        });
    }

    function scan(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var list = scope.querySelectorAll('iframe[data-consent-src]');

        for (var i = 0; i < list.length; i++) gate(list[i]);
        if (scope !== document && scope.matches && scope.matches('iframe[data-consent-src]')) gate(scope);
    }

    function release() {
        var list = pending;
        var runs = callbacks;

        pending = [];
        callbacks = [];
        list.forEach(function (entry) { load(entry.iframe, entry.placeholder); });
        runs.forEach(function (fn) {
            try { fn(); } catch (e) { console.error(e); }
        });
    }

    function refresh() {
        if (allowed) return;
        if (!readConsent()) return;

        allowed = true;
        release();
    }

    function requestApi() {
        if (apiRequested) return;
        apiRequested = true;

        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
                refresh();
            });
        }
    }

    // Fuer Skripte, die dynamisch iframes oder Player erzeugen
    function onConsent(fn) {
        if (allowed) {
            fn();
        } else {
            callbacks.push(fn);
        }
    }

    // Platzhalter in Container-Elementen (z. B. Platzhalter-divs fuer die YouTube-API)
    function whenAllowed(elements, kind, fn) {
        var done = false;
        var boxes = [];

        function run() {
            if (done) return;
            done = true;
            boxes.forEach(function (box) {
                if (box.parentNode) box.parentNode.removeChild(box);
            });
            fn();
        }

        if (allowed) {
            run();
            return;
        }

        Array.prototype.forEach.call(elements.jquery ? elements.get() : elements, function (element) {
            var built = buildPlaceholder(kind);

            built.box.classList.add('is-ratio');
            built.button.addEventListener('click', function () { run(); });
            element.parentNode.insertBefore(built.box, element);
            boxes.push(built.box);
        });

        callbacks.push(run);
    }

    window.MszConsentEmbed = {
        isAllowed: function () { return allowed; },
        onConsent: onConsent,
        whenAllowed: whenAllowed,
        scan: scan
    };

    document.addEventListener('visitorConsentCollected', function () {
        requestApi();
        refresh();
    });

    // Dynamisch eingefuegte iframes (Tab-Wechsel im Store-Locator, Popups, Slider)
    if ('MutationObserver' in window) {
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    var node = mutation.addedNodes[i];
                    if (node.nodeType === 1) scan(node);
                }
            });
        }).observe(document.documentElement, { childList: true, subtree: true });
    }

    refresh();
    scan(document);
    requestApi();
})();
